import React from "react";
import PropTypes from "prop-types";
import "./style.css";

const valueType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.bool,
]);

const propTypes = {
  labels: PropTypes.shape({
    left: {
      title: PropTypes.string.isRequired,
      value: valueType,
    },
    center: {
      title: PropTypes.string.isRequired,
      value: valueType,
    },
    right: {
      title: PropTypes.string.isRequired,
      value: valueType,
    },
  }),
  onChange: PropTypes.func.isRequired,
  styles: PropTypes.object,
};

const defaultProps = {
  labels: {
    left: {
      title: "left",
      value: "left",
    },
    center: {
      title: "center",
      value: "center",
    },
    right: {
      title: "right",
      value: "right",
    },
  },
  onChange: (value) => console.info("value:", value),
};

class TripleToggleSwitch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      switchPosition: "left",
    };
  }

  handleChange = (value) => {
    if (this.props.loadingTransaction) return;
    this.props.onChange(value);
    this.setState({ switchPosition: value });
  };

  getSwitchLeft = () => {
    const positions = {
      left: 3,
      center: 85,
      right: 167
    };
    return positions[this.state.switchPosition];
  };

  render() {
    const { labels , loadingTransaction} = this.props;

    console.log("loadingTransaction 2",loadingTransaction)
    return (
      <>
        <style>{`

          input[type="radio"] {
            display: none !important;
          }

          .toggle-main-container {
            display: inline-block;
            vertical-align: middle;
            width: 250px;
            height: 36px;
            border-radius: 100px;
            background-color: white;
            position: relative;
            box-shadow: 1px 1px 10px 1px rgba(0, 0, 0, 0.5);
          }

          .toggle-switch-slider {
            height: 30px;
            width: 80px;
            background-color: #4f46e5;
            border-radius: 100px;
            position: absolute;
            top: 3px;
            transition: left 0.3s ease-in-out;
            z-index: 1;
          }

          .toggle-labels-wrapper {
            display: flex;
            position: relative;
            height: 100%;
          }

          .toggle-option {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 36px;
            width: 80px;
            position: relative;
            z-index: 2;
          }

          .toggle-option:nth-child(2) {
            margin-left: 5px;
          }

          .toggle-option:nth-child(3) {
            margin-left: 5px;
          }

          .toggle-input {
            display: none;
          }

          .toggle-label-text {
            cursor: pointer;
            color: black;
            transition: color 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
          }

          .toggle-label-text.active {
            color: white;
          }

          .toggle-label-text h4 {
            margin: 0;
            font-size: 15px;
            font-weight: 400;
            pointer-events: none;
          }
        `}</style>

        <div
          className={`toggle-main-container
            ${loadingTransaction ? "opacity-60 cursor-not-allowed pointer-events-none" : "cursor-pointer"}
          `}
        >
          <div 
            className="toggle-switch-slider"
            style={{ left: `${this.getSwitchLeft()}px` }}
          />
          
          <div className="toggle-labels-wrapper">
            <div className="toggle-option">
              <input
                className="toggle-input"
                defaultChecked
                onChange={(e) => this.handleChange(e.target.value)}
                name="map-switch"
                id="left"
                type="radio"
                value="left"
                disabled={loadingTransaction}
              />
              <label
                className={`toggle-label-text ${
                  this.state.switchPosition === "left" ? "active" : ""
                } ${loadingTransaction ? "cursor-not-allowed" : "cursor-pointer"}`}
                htmlFor="left"
              >
                <h4>{labels.left.title}</h4>
              </label>
            </div>

            <div className="toggle-option">
              <input
                className="toggle-input"
                onChange={(e) => this.handleChange(e.target.value)}
                name="map-switch"
                id="center"
                type="radio"
                value="center"
                disabled={loadingTransaction}
              />
              <label
                className={`toggle-label-text ${
                  this.state.switchPosition === "center" ? "active" : ""
                } ${loadingTransaction ? "cursor-not-allowed" : "cursor-pointer"}`}
                htmlFor="center"
              >
                <h4>{labels.center.title}</h4>
              </label>
            </div>

            <div className="toggle-option">
              <input
                className="toggle-input"
                onChange={(e) => this.handleChange(e.target.value)}
                name="map-switch"
                id="right"
                type="radio"
                value="right"
                disabled={loadingTransaction}
              />
              <label
                className={`toggle-label-text ${
                  this.state.switchPosition === "right" ? "active" : ""
                } ${loadingTransaction ? "cursor-not-allowed" : "cursor-pointer"}`}
                htmlFor="right"
              >
                <h4>{labels.right.title}</h4>
              </label>
            </div>
          </div>
        </div>
      </>
    );
  }
}

TripleToggleSwitch.propTypes = propTypes;
TripleToggleSwitch.defaultProps = defaultProps;

export default TripleToggleSwitch;